import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { replaceImagePath } from '../../../lib/media-path-replacer';
import Accordion from '../../accordion';
import { Body } from '../../typography';

const Container = styled.div`
    padding-bottom: 16px;

    & > div:not(:last-child) {
        margin-bottom: 8px;
    }
`;

export const ImagesContainer = styled.div`
    & > img {
        display: block;
        width: 100%;
    }

    & > img:not(:last-child) {
        margin-bottom: 8px;
    }
`;

const DEFAULT_TITLE = 'Esercizio guida';

export const parseGuide = (guides) => {
    const parser = new DOMParser();

    const result = [];

    for (let i = 0; i < guides.length; i++) {
        const currentGuide = guides[i].xml;
        const document = parser.parseFromString(currentGuide, 'application/xml');
        const parsedPublicTitle = document.getElementsByTagName('public_title')[0];

        let publicTitle;
        if (parsedPublicTitle && parsedPublicTitle.textContent) {
            publicTitle = parsedPublicTitle.textContent;
        } else {
            publicTitle = `${DEFAULT_TITLE} ${i + 1}`;
        }

        const iterator = document.evaluate('//guide//img/@src', document, null, XPathResult.ANY_TYPE, null);

        const guidesJSON = [];
        let thisSrc = iterator.iterateNext();
        while (thisSrc) {
            guidesJSON.push({ src: replaceImagePath(thisSrc.nodeValue) });
            thisSrc = iterator.iterateNext();
        }

        result.push({ title: publicTitle, content: guidesJSON });
    }

    return result;
};

const GuideType = ({ guides }) => {
    const parsedGuide = parseGuide(guides);

    return (
        <Container>
            {parsedGuide.map((g, index) => {
                return (
                    <Accordion key={index}>
                        <Body lv={4} fontWeight="semi-bold">
                            {g.title}
                        </Body>
                        <ImagesContainer>
                            {g.content.map((content, indexImages) => {
                                return <img key={indexImages} src={content.src} alt="Immagine guida" />;
                            })}
                        </ImagesContainer>
                    </Accordion>
                );
            })}
        </Container>
    );
};

GuideType.propTypes = {
    guides: PropTypes.array,
};

export default GuideType;
